var React = require('react');

function DnsIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M35 8V5H33V8H6V24H33V28H16L6 36L16 44H33V63H35V44H62V28H35V24H52L62 16L52 8H35ZM51.2984 10H8V22H51.2984L58.7984 16L51.2984 10ZM16.7016 30L9.20156 36L16.7016 42H60V30H16.7016Z","fill":"#5FD800"}));
}

DnsIcon.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = DnsIcon;

DnsIcon.default = DnsIcon;
